import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Sparkles } from "lucide-react";

export default function ComingSoon({ title, description, features }) {
  return (
    <div className="px-4 sm:px-8 lg:px-10 py-12 max-w-3xl mx-auto" data-testid={`coming-soon-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <Link to="/platform" className="inline-flex items-center gap-2 text-sm text-navy/60 hover:text-navy mb-6">
        <ArrowLeft size={14} /> Back to dashboard
      </Link>
      <div className="rounded-xl bg-white border border-navy/10 p-8 sm:p-10 text-center shadow-sm">
        <div className="w-14 h-14 mx-auto rounded-full bg-gradient-to-br from-saffron/20 to-saffron/5 flex items-center justify-center mb-4">
          <Sparkles size={22} className="text-saffron" />
        </div>
        <p className="text-[10px] uppercase tracking-[0.3em] text-saffron">Coming soon</p>
        <h1 className="font-display text-3xl text-navy mt-2">{title}</h1>
        <p className="text-navy/65 mt-3 max-w-xl mx-auto">{description}</p>
        {features && features.length > 0 && (
          <ul className="mt-6 inline-block text-left text-sm text-navy/75 space-y-1.5">
            {features.map((f) => (
              <li key={f} className="flex gap-2">
                <span className="text-saffron">·</span>
                <span>{f}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
